import { Card, Spin, Badge } from "antd";
import Meta from "antd/es/card/Meta";
import React, { useEffect } from "react";
import { useAuth, usePlayrooms } from "../../context/PlayroomsContext";
import playroomService from "../../services/playroom.service";
import { useNavigate } from "react-router-dom";
import { useBooking } from "../../context/BookingContext";
import { EnvironmentFilled, EnvironmentOutlined, EnvironmentTwoTone, PhoneOutlined, PhoneTwoTone } from "@ant-design/icons";
import { CrownTwoTone } from "@ant-design/icons"; // Crown icon for premium badge
import LocationIcon from "../../icons/LocationIcon";
import PhoneIcon from "../../icons/PhoneIcon";
import PremiumIcon from "../../icons/PremiumIcon";

export default function InitialListOfPlayrooms() {
  const { allPlayrooms, setAllPlayrooms, setChoosenPlayroom } = usePlayrooms();
  const navigate = useNavigate();
  const { updateBooking } = useBooking();

  useEffect(() => {
    fetchPlayrooms();
  }, []);

  const fetchPlayrooms = () => {
    playroomService
      .getAllPlayrooms(1000, 1)
      .then((response) => {
        if (response.status === 200) {
          // Filter for active playrooms
          const activePlayrooms = response.data.items.filter(
            (playroom) => playroom.status === "PLAYROOM_ACTIVE"
          );

          // Split playrooms into premium and non-premium
          const premiumPlayrooms = activePlayrooms.filter(
            (playroom) => playroom.isPremium
          );
          const nonPremiumPlayrooms = activePlayrooms.filter(
            (playroom) => !playroom.isPremium
          );

          // Function to shuffle an array
          const shuffleArray = (array) => {
            return array.sort(() => Math.random() - 0.5);
          };

          // Shuffle both premium and non-premium playrooms
          const shuffledPremiumPlayrooms = shuffleArray(premiumPlayrooms);
          const shuffledNonPremiumPlayrooms = shuffleArray(nonPremiumPlayrooms);

          // Concatenate premium first, then non-premium
          const sortedPlayrooms = [...shuffledPremiumPlayrooms, ...shuffledNonPremiumPlayrooms];

          // Set the state with the sorted and shuffled playrooms
          setAllPlayrooms(sortedPlayrooms);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const onPlayroomClick = (playroom) => {
    setChoosenPlayroom(playroom);
    updateBooking("playroomId", playroom.id);
    updateBooking("dateString", "");
    updateBooking("packageId", "");
    navigate("/playroom-details");
  };

  return (
    <div className="p-4 flex justify-center min-h-screen">
      <div className="w-full lg:px-[150px]">
        {allPlayrooms && allPlayrooms.length > 0 ? (
          <div className={`grid grid-cols-1 lg:grid-cols-2 gap-4`}> {/* Adjust to have 1 column for small screens, 2 for large screens */}
            {allPlayrooms.map((playroom) => (
              <div
                key={playroom.id}
                className="w-full p-2 rounded-t-[30px] md:rounded-t-[40px]"
              >
                <Card
                  key={playroom.id}
                  hoverable
                  className="h-auto shadow-lg flex flex-col justify-between rounded-[30px] md:rounded-[40px]"
                  onClick={() => onPlayroomClick(playroom)}
                  cover={
                    <div className="h-48 sm:h-56 md:h-60 lg:h-64 xl:h-72 overflow-hidden">
                      <img
                        alt={playroom.name}
                        src={playroom.photos[0]?.photoUrl}
                        className="w-full h-full object-cover rounded-t-[30px] md:rounded-t-[40px]"
                      />
                    </div>
                  }
                >
                  <Meta
                    title={
                      <div className="grid grid-cols-[80%_20%] gap-2">
                        {/* Left side (80%) */}
                        <div className="flex flex-col text-left gap-2 md:pt-2">
                          <span className="md:text-3xl text-2xl text-footerBlue font-bold">
                            {playroom.name}
                          </span>
                          <div className="flex items-center text-cardDetailsGray text-sm lg:text-sm gap-1">
                            <EnvironmentOutlined style={{
                              color: "#00223E"
                            }} />
                            <span>{playroom.location}</span>
                          </div>

                        </div>
                        {/* Right side (20%) */}
                        <div className="flex items-start justify-center w-18 h-18 lg:w-20 lg:h-20 p-2 lg:p-0 pb-3">
                          {playroom.isPremium && (
                            <PremiumIcon />
                          )}

                        </div>

                      </div>
                    }
                  />
                </Card>
              </div>
            ))}
          </div>
        ) : (
          <Spin />
        )}
      </div>
    </div>
  );
}
